<template>
  <div class="campaignReport">
    <div class="campaignReport__header">
      <div class="campaignReport__header__title">
        <h1 class="medium-title">Campaign Report</h1>
      </div>
      <div class="campaignReport__header__menu">
        <ul>
          <router-link tag="li" :to="{ name: 'audience'}">Audience</router-link>
          <router-link tag="li" :to="{ name: 'demographic'}">Demographic</router-link>
          <router-link tag="li" :to="{ name: 'impactdashboard'}">Impact</router-link>
        </ul>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'adx-campaign-report',
  components: {
    
  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>